import { MixpanelCardApplylEvent } from '@sunbit-dev/common/enums/cardApply/MixpanelCardApplylEvent';
import mixpanel from 'mixpanel-browser';
import { useSelector } from 'react-redux';
import { selectLandingDetails } from '../../selectors';
import { useCallback } from 'react';

export const useMixpanel = () => {
  const applicationDetails = useSelector(selectLandingDetails);
  const trackForMixPanel = useCallback(
    (eventName: MixpanelCardApplylEvent, payload?: Object): void => {
      mixpanel.track(eventName, { ...payload, applicationId: applicationDetails.applicationId });
    },
    [applicationDetails]
  );
  return { trackForMixPanel };
};
